import { ClientError, GraphQLClient, type Variables } from 'graphql-request';
import { AsyncResult } from '../core';
import { isAbortError } from '../core/errorUtils';
import { apiErrorResult, IApiOriginalError } from './apiError';
import { ApiRequestParams } from './apiSchema';

export async function runGraphQlApiRequest<TData = unknown, TVars extends Variables = Variables>(params: ApiRequestParams<TVars>): AsyncResult<TData> {

  const {
    document: doc,
    variables: vars,
    endpoint,
    token
  } = params;

  const client = new GraphQLClient(endpoint, {
    mode: 'cors',
    signal: params.signal,
    headers: params.headers,
  });

  if (token)
    client.setHeader('Authorization', token);

  try {
    const result = await client.request<TData>({ document: doc, variables: vars });
    return [result];
  } catch (err) {

    if (isAbortError(err))
      return apiErrorResult('RequestAborted', null, err);

    if (err instanceof ClientError) {

      const message = err.message.split(':')[0];
      console.error('GraphQL Error', message);

      if ((err.response.errors as IApiOriginalError[] | undefined)?.some(error => error.errorType === 'MfaRequired'))
        return apiErrorResult('MfaRequired', 'Complete two-factor authentication to continue.', err);

      if (err.response.status === 401)
        return apiErrorResult('ProviderNotAuthorized', message, err);

      else if (message === 'Unauthorized')
        return apiErrorResult('NotAuthorized', message, err);

      return apiErrorResult('ProviderError', message, err);
    }

    const message = err instanceof Error ? err.message : null;
    return apiErrorResult('ProviderError', message, err instanceof Error ? err : undefined);
  }
}
